import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type {
  Account,
  AccountsListResponse,
  CreateAccountInput,
  UpdateAccountInput,
} from "@money/shared";
import { apiFetch } from "./client";

export const accountsKey = ["accounts"] as const;

export function useAccounts() {
  return useQuery({
    queryKey: accountsKey,
    queryFn: () => apiFetch<AccountsListResponse>("/accounts"),
    staleTime: 30_000,
  });
}

export function useCreateAccount() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateAccountInput) =>
      apiFetch<Account>("/accounts", { method: "POST", body: input }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: accountsKey });
    },
  });
}

export function useUpdateAccount() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { id: string; patch: UpdateAccountInput }) =>
      apiFetch<Account>(`/accounts/${input.id}`, {
        method: "PATCH",
        body: input.patch,
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: accountsKey });
    },
  });
}

export function useDeleteAccount() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => apiFetch<void>(`/accounts/${id}`, { method: "DELETE" }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: accountsKey });
    },
  });
}
